import {ModelMappingRuleLabels, ModelMappingRules} from "../../../formability/mappingBuilder/enums/model-mapping-rules";
import {IDefaultVOption} from "~/interfaces/vSelectInterfaces";
import ModelMapping from "~/models/mapping/modelMapping";

export default class ModelMappingDefinition {
  static getOneToOneRuleOptions(modelMapping: ModelMapping): IDefaultVOption[] {
    const options = [
      {label: ModelMappingRuleLabels[ModelMappingRules.CreateNew], value: ModelMappingRules.CreateNew},
      {label: ModelMappingRuleLabels[ModelMappingRules.UpdateCreate], value: ModelMappingRules.UpdateCreate},
      {label: ModelMappingRuleLabels[ModelMappingRules.UpdateIgnore], value: ModelMappingRules.UpdateIgnore},
    ]

    /**
     * Only include this rule if source is capable of providing a record ID
     * and the destination has the ability to consume said ID and establish a left-right relationship
     */
    if (modelMapping.sourceOrigin.canMatchUpdateRelationship && modelMapping.destinationOrigin.canConsumeRecordId) {
      options.push({
        label: ModelMappingRuleLabels[ModelMappingRules.MatchUpdateRelationship],
        value: ModelMappingRules.MatchUpdateRelationship,
      },
      {
        label: ModelMappingRuleLabels[ModelMappingRules.MatchReplaceRelationship],
        value: ModelMappingRules.MatchReplaceRelationship,
      })
    }
    return options
  }

  static getOneToManyRuleOptions(modelMapping: ModelMapping): IDefaultVOption[] {
    const options = [
      {label: ModelMappingRuleLabels[ModelMappingRules.AddToCollection], value: ModelMappingRules.AddToCollection},
      {label: ModelMappingRuleLabels[ModelMappingRules.UpdateOrAddToCollection], value: ModelMappingRules.UpdateOrAddToCollection},
      {label: ModelMappingRuleLabels[ModelMappingRules.DisconnectAndAddToCollection], value: ModelMappingRules.DisconnectAndAddToCollection},
      {label: ModelMappingRuleLabels[ModelMappingRules.DeleteAndAddToCollection], value: ModelMappingRules.DeleteAndAddToCollection},
    ]

    /**
     * Only include this rule if source is capable of providing a record ID
     * and the destination has the ability to consume said ID and establish a left-right relationship
     */
    if (modelMapping.sourceOrigin.canMatchUpdateRelationship && modelMapping.destinationOrigin.canConsumeRecordId) {
      options.push({
        label: ModelMappingRuleLabels[ModelMappingRules.MatchAndAddToCollection],
        value: ModelMappingRules.MatchAndAddToCollection,
      },
      {
        label: ModelMappingRuleLabels[ModelMappingRules.MatchAndReplaceCollection],
        value: ModelMappingRules.MatchAndReplaceCollection,
      },
      {
        label: ModelMappingRuleLabels[ModelMappingRules.MatchUpdateRelationship],
        value: ModelMappingRules.MatchUpdateRelationship,
      })
    }
    return options
  }

  /**
   * @return {Array<number>} array of sort orders leading down through nested model mappings, includes self
   */
  static sortOrderPath(modelMapping: ModelMapping): number[] {
    const path = []
    let currentModelMapping = modelMapping
    while (currentModelMapping) {
      path.unshift(currentModelMapping.sort_order)
      currentModelMapping = currentModelMapping.parentModelMapping
    }
    return path
  }

  static baseViewId(modelMapping: ModelMapping): string {
    return ModelMappingDefinition.sortOrderPath(modelMapping).join('_')
  }

  static ruleViewId(modelMapping: ModelMapping): string {
    return `#rule_${ModelMappingDefinition.baseViewId(modelMapping)}`
  }

  static documentActionsViewId(modelMapping: ModelMapping): string {
    return `#document-actions-button-${ModelMappingDefinition.baseViewId(modelMapping)}`
  }
}
